import React from 'react';
import { Container, Paper, Stack, Group, Text, Badge } from '@mantine/core';
import { IconBlockquote } from '@tabler/icons-react';
import BlockManagement from '../../features/coordinator/blocks/BlockManagement';

/**
 * Coordinator Block Management Page
 * 
 * Provides access to block management for coordinators
 * Includes the existing BlockManagement component
 */
const CoordinatorBlockManagement: React.FC = () => {
  return (
    <Container size="xl" py="md">
      <Stack gap="md">
        {/* Header */}
        <Paper p="md" radius="md" withBorder>
          <Group justify="space-between">
            <Group gap="sm">
              <IconBlockquote size={24} />
              <Text fw={700} size="xl">Block Management</Text>
            </Group>
            <Badge size="lg" variant="light" color="green">
              Full Management Access
            </Badge>
          </Group>
        </Paper>

        {/* Block Management Interface */}
        <BlockManagement />
      </Stack>
    </Container>
  );
};

export default CoordinatorBlockManagement;
